export type CursorRulesLoadState = 'loading' | 'ready' | 'error';

export const SETUP_PROMPT_LOAD_ERROR =
  'Could not load the setup prompt from the server — press Refresh or retry';

/** Storybook/test preview only — never a live Cursor setup prompt. */
export const PREVIEW_SETUP_PROMPT = [
  '[PREVIEW — not a live setup prompt]',
  'Please create these files exactly as provided:',
  'setup_prompt_version: preview',
  'Authorization: Bearer <your_mcp_key>',
  'This is a static preview of the MCP connection card. Do not paste this into Cursor.',
].join('\n');

export function injectMcpKey(template: string | null | undefined, key: string | null): string | null {
  if (!template) return null;
  if (!key) return template;
  return template
    .replaceAll('YOUR_MCP_KEY_HERE', key)
    .replaceAll('<your_mcp_key>', key);
}

export function hasEmbeddedMcpKey(template: string | null | undefined): boolean {
  if (!template) return false;
  return !template.includes('YOUR_MCP_KEY_HERE') && !template.includes('<your_mcp_key>');
}

const KEPT_CONNECTION_NAMES: Record<string, string> = {
  app_EXbxs1vNsJiF: 'dc-markets',
  app_liLa8A7VCWzj: 'dc-geo',
  app_LE9F5NpO6Wer: 'dc-farm-admin',
};

export function cursorConnectionName(appName: string, appId?: string, collide = false): string {
  if (appId && KEPT_CONNECTION_NAMES[appId]) return KEPT_CONNECTION_NAMES[appId];
  const ascii = String(appName || '').replace(/[^\x00-\x7F]/g, '');
  const slug = ascii.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 32).replace(/-+$/g, '') || 'app';
  const base = `dc-${slug}`;
  if (!collide || !appId) return base;
  return `${base}-${appId.slice(-4).toLowerCase()}`;
}

export function buildMcpJson(appId: string, endpoint: string, key: string | null, appName?: string): string {
  return JSON.stringify({
    mcpServers: {
      [cursorConnectionName(appName || appId, appId)]: {
        url: endpoint,
        headers: { Authorization: `Bearer ${key || '<your_mcp_key>'}` },
      },
    },
  }, null, 2);
}
